<div class="cads-account-row">
  @if (resolvedLeadingIconConfig(); as leadCfg) {
    <div class="cads-account-row__leading" aria-hidden="true">
      <cads-icon-view-bit [config]="leadCfg" />
    </div>
  }
  <div class="cads-account-row__heading">
    <cads-heading-detail-bit [config]="config().accountRowHeading" />
  </div>
  @if (config().accountRowDetails; as detailsCfg) {
    <div class="cads-account-row__amount">
      <cads-amount-detail-bit [config]="detailsCfg" />
    </div>
  }
</div>
